// extracted by mini-css-extract-plugin
export default {"input":"SearchForm_input__7U8V+","results":"SearchForm_results__+LKvk"};